import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pluginPlatformApi, type PlatformDashboard } from '../../api/pluginplatform';

const NAV = [
  { to: '/plugins/manager', label: 'Plugin Manager' },
  { to: '/plugins/marketplace', label: 'Marketplace' },
  { to: '/plugins/publishers', label: 'Publishers' },
  { to: '/plugins/health', label: 'Health Dashboard' },
  { to: '/developer', label: 'Developer Center' },
];

export function PluginHubPage() {
  const [dashboard, setDashboard] = useState<PlatformDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void pluginPlatformApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Installed', value: dashboard.installed_plugins },
        { label: 'Active', value: dashboard.active_plugins },
        { label: 'Marketplace', value: dashboard.marketplace_count },
        { label: 'Publishers', value: dashboard.publisher_count },
        { label: 'Downloads', value: dashboard.total_downloads },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Plugin Platform</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise plugin SDK, extension framework and marketplace ecosystem.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
